<template>
	<div class="mainPage">
		<div class="flex just-between">
			<div>
				<el-button
					type="primary"
					plain
					icon="el-icon-circle-plus"
					:size="inputSize"
					@click="handleAdd()"
					>增 加</el-button
				>
			</div>
			<el-form :inline="true" :model="queryForm">
				<el-form-item label="用户名/姓名">
					<el-input
						v-model="queryForm.q"
						:size="inputSize"
						placeholder="请输入用户名或姓名"
						auto-complete="off"
					></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-select
						v-model="queryForm.status"
						clearable
						:size="inputSize"
						placeholder="用户状态"
					>
						<el-option :value="1" label="启用"></el-option>
						<el-option :value="0" label="停用"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button
						type="primary"
						icon="el-icon-search"
						:size="inputSize"
						@click="getPageList"
						>查 询</el-button
					>
				</el-form-item>
			</el-form>
		</div>

		<el-table :data="pageList.content">
			<el-table-column
				type="index"
				label="序号"
				width="60"
				:index="indexMethod"
			></el-table-column>
			<el-table-column
				prop="username"
				label="用户名"
			></el-table-column>
			<el-table-column
				prop="name"
				label="姓名"
			></el-table-column>
			<el-table-column prop="status" label="状态">
				<template slot-scope="scope">
					<el-tag
						type="success"
						:size="inputSize"
						v-if="scope.row.status === 1"
						>启用</el-tag
					>
					<el-tag
						type="danger"
						:size="inputSize"
						v-if="scope.row.status === 0"
						>停用</el-tag
					>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注"></el-table-column>
			<el-table-column
				prop="createTime"
				label="创建时间"
			></el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button
						type="text"
						icon="el-icon-edit"
						:size="inputSize"
						@click="handleEdit(scope.row)"
						>修改</el-button
					>
					<el-button
						type="text"
						icon="el-icon-edit"
						:size="inputSize"
						@click="handleResetPassword(scope.row)"
						>修改密码</el-button
					>
					<el-button
						type="text"
						icon="el-icon-delete"
						:size="inputSize"
						@click="handleDelete(scope.row)"
						>删除</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="queryForm.pageNum"
			:page-size="queryForm.pageSize"
			:page-sizes="[10, 20, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="pageList.totalElements"
		>
		</el-pagination>

		<user-dialog
			:visible="userDialog.visible"
			:id="userDialog.id"
			@close="userDialogClosed"
		></user-dialog>
		<reset-password-dialog
			:visible="passwordDialog.visible"
			:user="passwordDialog.user"
			@close="userDialogClosed"
		></reset-password-dialog>
	</div>
</template>

<script>
import UserDialog from "./UserDialog";
import ResetPasswordDialog from "./ResetPasswordDialog.vue";

export default {
	components: {
		UserDialog,
		ResetPasswordDialog,
	},
	data() {
		return {
			inputSize: "small",
			queryForm: {
				q: "",
				status: null,
				pageNum: 1,
				pageSize: 10,
			},
			pageList: {
				content: [],
				totalElements: 0,
			},
			userDialog: {
				visible: false,
				id: "",
			},
			passwordDialog: {
				visible: false,
				user: {},
			},
		};
	},
	methods: {
		indexMethod(index) {
			index =
				index +
				1 +
				(this.queryForm.pageNum - 1) * this.queryForm.pageSize;
			return index;
		},
		getPageList() {
			this.$api.system.getUserPageList(this.queryForm).then((res) => {
				if (res.code === 200) {
					res.data.content.forEach((item) => {
						item.createTime = item.createTime
							? item.createTime.split("T")[0]
							: "";
						item.modifyTime = item.modifyTime
							? item.modifyTime.split("T")[0]
							: "";
					});
					this.pageList = res.data;
				}
			});
		},
		handleSizeChange(pageSize) {
			this.queryForm.pageSize = pageSize;
			this.getPageList();
		},
		handleCurrentChange(pageNum) {
			this.queryForm.pageNum = pageNum;
			this.getPageList();
		},
		handleAdd() {
			this.userDialog.id = "";
			this.userDialog.visible = true;
		},
		handleEdit(data) {
			this.userDialog.visible = true;
			this.userDialog.id = data.id;
		},
		handleResetPassword(data) {
			this.passwordDialog.user = data;
			this.passwordDialog.visible = true;
		},
		handleDelete(data) {
			this.$confirm("确定要删除用户【" + data.name + "】吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$api.system.removeUserInfo(data.id).then((res) => {
					if (res.code === 200) {
						this.$message.success("删除成功");
						this.getPageList();
					} else {
						this.$message.error(res.message);
					}
				});
			});
		},
		userDialogClosed(success) {
			this.userDialog.visible = false;
			this.passwordDialog.visible = false;
			if (success) {
				this.getPageList();
			}
		},
	},
	mounted() {
		this.getPageList();
	},
};
</script>
